import { ExamplePagesOccupations, SEO_URL_EXAMPLE_PAGES_SUFIX } from "@authory-packages/seo-static-data";
import { ExamplesPageLayout } from "../../pagelayouts/examples";
import { APPLICATION_ROUTES } from "../../shared-logic/routes";

const ExampleJobPage = () => (
    <ExamplesPageLayout
        title={<>See Portfolio Examples by Profession</>}
        description={
            <>
                Browse real Authory portfolio examples curated by specific professions, from freelance journalists to academics, consultants, and
                more. Find inspiration in how others in your role present their work.
            </>
        }
        panelLinks={ExamplePagesOccupations.map((occ) => ({
            url: `${APPLICATION_ROUTES.EXAMPLES}/${occ.key}${SEO_URL_EXAMPLE_PAGES_SUFIX}`,
            label: occ.occupation
        }))}
        categoriesLinks={[]}
        masonryItems={{ users: [] }}
        ogTitle={"Portfolio Examples by Profession | Authory"}
        ogDescription={
            "Explore real-world Authory portfolio examples organized by profession. See how experts in your field present their published work."
        }
        embedConf={[]}
        faq={[]}
    />
);

export default ExampleJobPage;
